import { useGetAllExamCoursesQuery } from '@report/graphql';
import { PaperSection, Flex } from '@shared/components';
import { useMemo } from 'react';

import { QSetUsageReportExportButton } from '../question-usage-by-qset-report-export-button';
import { QuestionUsageByQSetReportFilterSection } from '../question-usage-by-qset-report-filter-section';
import { QuestionUsageByQSetReportTable } from '../question-usage-by-qset-report-table';

export default function QuestionUsageByQSetReportList() {
  const { data: examCourseData, loading: examCoursesLoading } = useGetAllExamCoursesQuery();
  const examCoursesOptions = useMemo(
    () =>
      examCourseData?.reportGetAllExamCourses.examCourses.map((course) => ({
        label: course.code,
        value: course.id,
      })) ?? [],
    [examCourseData],
  );
  return (
    <PaperSection
      title='รายงานการใช้งานข้อสอบแยกตามชุด'
      endAdornment={<QSetUsageReportExportButton />}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: (theme) => theme.spacing(6),
          p: (theme) => theme.spacing(4),
        }}
      >
        <QuestionUsageByQSetReportFilterSection
          examCoursesOptions={examCoursesOptions}
          loading={examCoursesLoading}
        />
        <QuestionUsageByQSetReportTable examCoursesOptions={examCoursesOptions} />
      </Flex>
    </PaperSection>
  );
}
